export default __webpack_public_path__ + "static/media/product-11 (2).c9bc2660.jpg";